import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { IUserFromStorage } from '../../Interfaces/IUser';

import '../../Shared/css/MisRutinas/cardio.css';

const Cardio = () => {
  const user: IUserFromStorage = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isPG = user.objetivo === 'PG';

  return (
    <div className="cardio-page">
      {/* Header */}
      <div className="cardio-header">
        <button className="cardio-back-btn" onClick={() => navigate('/misRutinas')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div>
          <span className="cardio-header-label">Tu complemento</span>
          <h1 className="cardio-header-title">
            {isPG ? 'Cardio · Pérdida de Grasa' : 'Cardio · Masa Muscular'}
          </h1>
        </div>
      </div>

      <div className="cardio-content">
        {/* Intro */}
        <div className="cardio-intro-card">
          <div className="cardio-intro-icon">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#E8A817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
            </svg>
          </div>
          <p className="cardio-intro-text">
            {isPG
              ? 'Incorporar sesiones de cardio aumenta la efectividad de tu entrenamiento y te brinda un impulso adicional en tu camino hacia un estilo de vida más saludable.'
              : 'El cardio juega un rol crucial no solo en mantener un porcentaje saludable de grasa corporal, sino también en fortalecer tu corazón y mejorar tu salud cardiovascular.'}
          </p>
        </div>

        {/* Stats Row */}
        <div className="cardio-stats-row">
          <div className="cardio-stat-card">
            <span className="cardio-stat-value">{isPG ? '3-5x' : '3x'}</span>
            <span className="cardio-stat-label">por semana</span>
          </div>
          <div className="cardio-stat-card">
            <span className="cardio-stat-value">{isPG ? '30' : '20-30'}</span>
            <span className="cardio-stat-label">min / sesión</span>
          </div>
        </div>

        {/* When Section */}
        <div className="cardio-section">
          <h2 className="cardio-section-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8A817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
            ¿Cuándo hacerlo?
          </h2>
          <div className="cardio-options">
            <div className="cardio-option">
              <span className="cardio-option-number">1</span>
              <div>
                <p className="cardio-option-title">Post-Entrenamiento</p>
                <p className="cardio-option-desc">Justo después de tu sesión de pesas. Aprovechas al máximo tu tiempo en el gym.</p>
              </div>
            </div>
            <div className="cardio-option">
              <span className="cardio-option-number">2</span>
              <div>
                <p className="cardio-option-title">Separado del Entrenamiento</p>
                <p className="cardio-option-desc">Divide tu actividad: pesas en la mañana y cardio en la tarde, o al revés.</p>
              </div>
            </div>
            <div className="cardio-option">
              <span className="cardio-option-number">3</span>
              <div>
                <p className="cardio-option-title">En Días Alternos</p>
                <p className="cardio-option-desc">Dedica los días entre tus sesiones de pesas exclusivamente al cardio.</p>
              </div>
            </div>
          </div>
        </div>

        {/* What Section */}
        <div className="cardio-section">
          <h2 className="cardio-section-title">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#E8A817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
            </svg>
            ¿Qué tipo de cardio?
          </h2>
          <p className="cardio-section-desc">Elige algo que disfrutes y te motive:</p>
          <div className="cardio-activities">
            <span className="cardio-activity-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
              </svg>
              Bailar
            </span>
            <span className="cardio-activity-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
              </svg>
              Correr
            </span>
            <span className="cardio-activity-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"/>
              </svg>
              Nadar
            </span>
            <span className="cardio-activity-pill">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/>
              </svg>
              Bicicleta
            </span>
          </div>
        </div>

        {/* Reminder */}
        <div className="cardio-reminder">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E8A817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
          </svg>
          <p>
            <strong>Recuerda:</strong> {isPG
              ? ' La clave está en la consistencia. Lo importante es cumplir con tu rutina de cardio semanal, adaptándola según tu disponibilidad.'
              : ' El objetivo es encontrar un equilibrio que te permita alcanzar tus metas de masa muscular, manteniendo un cuerpo y corazón saludables.'}
          </p>
        </div>

        {/* Back Button */}
        <button className="cardio-nav-btn" onClick={() => navigate('/misRutinas')}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
          Volver a Mis Rutinas
        </button>
      </div>
    </div>
  );
}

export default Cardio;
